<template>
  <div>
    <q-toolbar class="column">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('channels_disclosure') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/" />
        <q-breadcrumbs-el :label="$t('my_channels')" exact />
      </q-breadcrumbs>
    </q-toolbar>

    <q-separator spaced />

    <q-banner class="bg-cyan-2 text-info q-my-md" rounded>
      <q-item>
        <q-item-section top avatar>
          <q-icon name="mdi-information-outline" size="lg" />
        </q-item-section>
        <q-item-section>
          <q-item-label caption class="text-black">
            <strong>{{ $t('what_is_channel') }}</strong><br />
            {{ $t('what_is_channel_description') }}
            <strong>72h</strong>!
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-banner>

    <q-banner v-if="this.$moment().format('YYYY-MM-DD') < '2023-01-05'" class="text-negative q-my-md" rounded>
      <q-item>
        <q-item-section top avatar>
          <q-icon name="mdi-bullhorn-outline" size="lg" />
        </q-item-section>
        <q-item-section>
          <q-item-label caption class="text-black">
            <strong
              >Devido ao recesso de Final de Ano entre os dias 23/12 e 05/01, nosso prazo para aprovação de Canais pode
              ser maior que o período padrão de 72h.</strong
            >
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-banner>

    <div class="row">
      <q-space />
      <q-btn
        v-if="viewAdd"
        color="primary"
        icon="mdi-plus"
        :label="$t('add')"
        no-caps
        unelevated
        @click="ActionSetDialogChannel(true)"
      >
      </q-btn>
    </div>
  </div>
</template>

<script>
import ChannelMixin from '../../mixins/ChannelMixin';
import affiliateService from '../../services/AffiliateService';
export default {
  name: 'HeaderMyChannels',
  mixins: [ChannelMixin, affiliateService],

  /* data() {
        return {
        };
    }, */

  props: {
    viewAdd: {
      type: Boolean,
      default: false
    }
  }
};
</script>
